// Espelha os dados PÚBLICOS da loja no documento `lojas/{slug}` (leitura pública).
//
// Motivo: a loja pública (SitePublico) não pode ler `users/{uid}` — esse documento
// é privado (contém o token secreto do Mercado Pago em paymentConfig.mpAccessToken).
// Visitantes não logados teriam a leitura negada → "erro ao carregar dados".
// Por isso copiamos apenas o que pode ser público para `lojas/{slug}`.

import { doc, setDoc } from "firebase/firestore";
import { db } from "../firebase";
import { gerarSlug } from "./slug";
import { contatoPublico } from "./contatoLoja";

// Contas com dados compartilhados guardam produtos na raiz (espelha useFirebase.js / SitePublico)
const SHARED_DATA_EMAILS = ["matriz03d@gmail.com"];

// Slugs das lojas compartilhadas (produtos na raiz). Usado como fallback quando o
// doc `lojas/{slug}` ainda não foi migrado e não tem o campo `produtosNaRaiz`.
export const SHARED_SLUGS = ["matriz3d"];

// Campos de pagamento que PODEM ser públicos (mostrados ao comprador).
// NUNCA inclui mpAccessToken / mpDeviceId — esses são segredos do vendedor.
const PUB_PAYMENT_KEYS = ["pixEnabled", "pixChave", "pixBeneficiario", "pixCidade"];

export function configPagamentoPublico(paymentConfig = {}) {
  const pub = {};
  for (const k of PUB_PAYMENT_KEYS) {
    if (paymentConfig?.[k] !== undefined) pub[k] = paymentConfig[k];
  }
  return pub; // sem mpAccessToken / mpDeviceId
}

// Atualiza (merge) o doc público da loja. Só toca nos campos informados.
// logoSiteUrl é opcional — logo específica pra vitrine pública (cadastrada
// na aba Loja Online), quando o vendedor quer uma logo diferente da logo
// da empresa (Configurações → Conta). O fallback pra logo "normal" é
// resolvido em quem lê (SitePublico.jsx), não aqui.
// contato ({ whatsapp, instagram }) vem de Configurações → Loja e aparece na vitrine.
export async function espelharLojaPublica(uid, { empresa, nome, logoUrl, logoSiteUrl, email, paymentConfig, contato } = {}) {
  if (!uid) return;
  const slug = gerarSlug(empresa || "");
  if (!slug) return; // sem nome de empresa não há link público

  const payload = { uid, empresa: empresa || "", slug };
  if (nome        !== undefined) payload.nome        = nome || "";
  if (logoUrl     !== undefined) payload.logoUrl      = logoUrl || "";
  if (logoSiteUrl !== undefined) payload.logoSiteUrl  = logoSiteUrl || "";
  if (email    !== undefined) payload.produtosNaRaiz = SHARED_DATA_EMAILS.includes(email);
  if (paymentConfig !== undefined) payload.paymentConfig = configPagamentoPublico(paymentConfig);
  if (contato !== undefined) payload.contato = contatoPublico(contato);

  await setDoc(doc(db, "lojas", slug), payload, { merge: true });
}
